var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "step-form" }, [
    _c("div", { staticClass: "d-flex align-items-start mr-2" }, [
      _c(
        "button",
        {
          directives: [
            {
              name: "b-tooltip",
              rawName: "v-b-tooltip.hover.bottom",
              value: _setup.sidebarOpen ? "Collapse" : "Expand",
              expression: "sidebarOpen ? 'Collapse' : 'Expand'",
              modifiers: { hover: true, bottom: true },
            },
          ],
          staticClass: "sidebar-btn",
          on: { click: _setup.toggleSidebar },
        },
        [_c(_setup.Icon, { attrs: { icon: _setup.faSidebar } })],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "step-form-container" }, [
      _c(
        "div",
        { class: ["step-form-header", { "sidebar-open": _setup.sidebarOpen }] },
        _vm._l(_setup.headerElements, function (element) {
          return _c(
            "div",
            {
              key: element.id,
              class: [
                "form-step-nav-item",
                {
                  active: element.isActive,
                  completed: element.isCompleted,
                  clickable: element.isClickable,
                },
              ],
              on: {
                click: function ($event) {
                  return _setup.goToStep(element)
                },
              },
            },
            [
              _setup.sidebarOpen
                ? [
                    _c("div", { staticClass: "step-title" }, [
                      _c("span", { staticClass: "step-title-number" }, [
                        _vm._v(_vm._s(element.index + 1)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "step-title-text" }, [
                        _vm._v(_vm._s(element.title)),
                      ]),
                    ]),
                    _vm._v(" "),
                    element.subtitle
                      ? _c("div", { staticClass: "step-subtitle" }, [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(element.subtitle) },
                          }),
                        ])
                      : _vm._e(),
                  ]
                : [
                    _c("div", { staticClass: "step-title" }, [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.right",
                              value: element.title,
                              expression: "element.title",
                              modifiers: { right: true },
                            },
                          ],
                          staticClass: "step-title-number",
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(element.index + 1) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]),
                  ],
            ],
            2
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "step-section-content" },
        [
          _vm._t(`step-${_setup.currentStepIndex + 1}`, function () {
            return [_c("div", [_vm._v("No content")])]
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }